import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@mui/material";
import ChannelButtonBar from "../../../components/netfeedr/ChannelButtonBar";
import ChannelTable from "../../../components/netfeedr/ChannelTable";
import GroupButtonBar from "../../../components/netfeedr/GroupButtonBar";
import GroupTable from "../../../components/netfeedr/GroupTable";
import {listChannels} from "../../../features/netfeedr";
import axios from 'axios';
import { commonApiPromise } from '../../../common';
import DeleteChannelDialog from "../../../components/netfeedr/DeleteChannelDialog";
import NewChannelDialog from "../../../components/netfeedr/NewChannelDialog";
import EditChannelDialog from "../../../components/netfeedr/EditChannelDialog";
import NewGroupDialog from "../../../components/netfeedr/NewGroupDialog";
import EditGroupDialog from "../../../components/netfeedr/EditGroupDialog";
import DeleteGroupDialog from "../../../components/netfeedr/DeleteGroupDialog";

function NetfeedrSection(){
    
    const dispatch = useDispatch();
    const channels = useSelector(state => state.netfeedr.list);
    const toggleCount = useSelector(state => state.netfeedr.bulkToggleCount);
    const [selection, setSelection] = useState([]);
    const [groupSelection, setGroupSelection] = useState([]);
    const [search, setSearch] = useState("");
    const [groupSearch, setGroupSearch] = useState("");
    const [groups, setGroups] = useState([]);

    
    const filteredChannels = (channels || [])
    .filter(c => {
        const res = !search 
        || (c.channelName && typeof c.channelName === 'string' && c.channelName.toLowerCase().indexOf(search.toLowerCase())!==-1)
        || (c.channelId && (c.channelId + "").toLowerCase().indexOf(search.toLowerCase())!==-1)
        return res;
    });

    const filteredGroups = (groups || [])
    .filter(g => {
        const res = !groupSearch 
        || (g.groupLabel && typeof g.groupLabel === 'string' && g.groupLabel.toLowerCase().indexOf(groupSearch.toLowerCase())!==-1)
        return res;
    });


    useEffect(() => {
        setSelection((selection || []).filter(s => {
            return !!channels.find(r => r.id === s);
        }));
    }, [channels]);

    const loadGroups = () => {
        commonApiPromise(axios.get("/netfeedr/group_list"), dispatch)
        .then(data => {
            if (data) {
                setGroups(data);
            }
        })
        .catch(error => {
            console.error("Error loading groups:", error);
        });
    };

    useEffect(() => {
        dispatch(listChannels());
        loadGroups();
    }, [dispatch]);

    useEffect(() => {
        setSelection([]);
    },[toggleCount]);
    
    return <>
        <NewChannelDialog />
        <EditChannelDialog />
        <DeleteChannelDialog />
        <NewGroupDialog onGroupCreated={loadGroups} />
        <EditGroupDialog onGroupUpdated={loadGroups} />
        <DeleteGroupDialog onGroupDeleted={loadGroups} />

    <Typography variant="h4" gutterBottom>Groups</Typography>


        <GroupButtonBar selection={groupSelection} search={groupSearch} setSearch={setGroupSearch} />
        <GroupTable groups={filteredGroups} selection={groupSelection} setSelection={setGroupSelection} />
    
    <Typography variant="h4" gutterBottom>Channels</Typography>
        
        <ChannelButtonBar selection={selection} search={search} setSearch={setSearch} />
        <ChannelTable channels={filteredChannels} selection={selection} setSelection={setSelection} />
    </>
}
export default NetfeedrSection;